export default __webpack_public_path__ + "static/media/p2p-banners-cn.e2715511.webp";